import {ListItemProps} from 'component/partial/MetricSection/MetricSection';

import {MetricsSection} from '/constant/TestIDs';
import {
  REPORT_EARNED_ACCELERATOR_BONUS,
  REPORT_EARNED_CAB,
  REPORT_EARNED_CLIENT_SUPPORT_BONUS_PLUS,
  REPORT_EARNED_QSB,
  REPORT_QUALIFIED_FOR_INCENTIVE_TRIP,
  REPORT_RANK_UP,
} from '/enum/records.enum';
import {useTranslation} from '/provider/TranslationProvider';

import {
  CoachesToCelebrateSectionParams,
  HookReturnType,
} from './CoachesToCelebrateSection.types';
import RankUpItem from './RankUpItem';

import {FEATURE_FLAGS} from '/DevFeatureFlags';

export const useCoachesToCelebrateSection = ({
  clientAcquisitionBonus = 0,
  clientQuickStartBonus = 0,
  onShowReport = () => {},
  rankUp = 0,
  onShowInfoPopover = () => {},
  earnedAccelBonusCount = 0,
  earnedClientSupportBonusPlusCount = 0,
  showCSBPlus = false,
  showIncentiveTrip = false,
  qualifiedIncentiveTripCount = 0,
  showEarnedQSB = false,
}: CoachesToCelebrateSectionParams): HookReturnType => {
  const {tt, ts} = useTranslation('screen.teams.section.coachesToCelebrate');

  let listItems: ListItemProps[] = [
    {
      label: tt('rankUp', 'Rank Up'),
      value: rankUp,
      recordsName: REPORT_RANK_UP,
      component: RankUpItem,
      testID: MetricsSection.metricRankUp,
    },
  ];

  if (showIncentiveTrip) {
    listItems.push({
      label: tt('incentiveTrip', 'Qualified for Incentive Trip 2024'),
      value: qualifiedIncentiveTripCount,
      recordsName: REPORT_QUALIFIED_FOR_INCENTIVE_TRIP,
      testID: MetricsSection.metricQualifiedForIncentiveTrip,
    });
  }

  if (showCSBPlus) {
    listItems.push({
      label: tt('clientSupport', 'Earned Client Support Bonus+'),
      value: earnedClientSupportBonusPlusCount,
      recordsName: REPORT_EARNED_CLIENT_SUPPORT_BONUS_PLUS,
      testID: MetricsSection.metricEarnedClientSupportBonusPlus,
    });
  }

  if (FEATURE_FLAGS.showCabBonus) {
    listItems.push({
      label: tt('acquisitionBonus', 'Earned Client Acquisition Bonus'),
      value: clientAcquisitionBonus,
      recordsName: REPORT_EARNED_CAB,
      testID: MetricsSection.metricEarnedClientAcquisitionBonus,
    });
  }

  if (showEarnedQSB) {
    listItems.push({
      label: tt('quickstartBonus', 'Earned Quick Start Bonus'),
      value: clientQuickStartBonus,
      testID: MetricsSection.metricEarnedQuickStartBonus,
      recordsName: REPORT_EARNED_QSB,
    });
  }

  listItems.push({
    label: tt('coachAccelerator', 'Earned Coach Accelerator Bonus'),
    value: earnedAccelBonusCount,
    testID: MetricsSection.metricEarnedCoachAcceleratorBonus,
    recordsName: REPORT_EARNED_ACCELERATOR_BONUS,
  });

  const onInfoPress = () =>
    onShowInfoPopover({
      heading: tt('info.heading', 'Coaches to Celebrate'),
      body: tt(
        'info.body',
        'These Coaches have done something noteworthy! Why not reach out and celebrate their wins?',
      ),
    });

  const onItemPress = ({
    recordsName,
    value,
  }: {
    recordsName: string;
    value: number;
  }) => onShowReport({recordsName, loadingData: {total: value}});

  return {
    onItemPress,
    onInfoPress,
    listItems,
    tt,
    ts,
  };
};
